import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Chip, useTheme,
} from '@mui/material';

const formatDuration = (s) => {
  if (!s) return '—';
  const mins = Math.floor(s / 60);
  const secs = s % 60;
  if (mins < 1) return `${s}s`;
  return secs ? `${mins}m ${secs}s` : `${mins}m`;
};

const UserSessionsTab = ({ sessions }) => {
  const theme = useTheme();

  if (!sessions?.items?.length) {
    return <Typography variant="body2" sx={{ color: theme.palette.text.secondary, py: 3 }}>No sessions recorded.</Typography>;
  }

  return (
    <Box>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
        Showing {sessions.items.length} of {sessions.total} sessions
      </Typography>
      <TableContainer sx={{ borderRadius: '8px', border: `1px solid ${theme.palette.divider}` }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.action.hover }}>
              <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Duration</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Pages</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Device</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Browser</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>OS</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Entry Page</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sessions.items.map((s, i) => (
              <TableRow key={s.id || i}>
                <TableCell>
                  <Typography variant="body2">
                    {s.started_at ? new Date(s.started_at).toLocaleString() : '—'}
                  </Typography>
                </TableCell>
                <TableCell>{formatDuration(s.duration_seconds)}</TableCell>
                <TableCell>{s.page_count ?? '—'}</TableCell>
                <TableCell>
                  {s.device_type && <Chip label={s.device_type} size="small" sx={{ fontSize: '0.7rem' }} />}
                </TableCell>
                <TableCell><Typography variant="body2">{s.browser || '—'}</Typography></TableCell>
                <TableCell><Typography variant="body2">{s.os || '—'}</Typography></TableCell>
                <TableCell>
                  <Typography variant="body2" noWrap sx={{ maxWidth: 200 }}>
                    {s.entry_page || '—'}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UserSessionsTab;
